const e = document.querySelector('.elite-feature-grid');
if (e) for (let i = 0; i < 5; i++) e.after(e.cloneNode(true));

document.addEventListener('click', function(e) {
  var el = e.target.closest('.tab-headings');
  if (!el) return;
  document.querySelectorAll('.tab-headings').forEach(function(t) { t.classList.remove('active-tab'); });
  el.classList.add('active-tab');
  var target = el.dataset.tab;
  document.querySelectorAll('.tab-content-wrapper').forEach(function(c) { c.classList.remove('active-content'); });
  if (target) document.querySelectorAll('.tab-content-wrapper.' + target).forEach(function(c) { c.classList.add('active-content'); });
});

function slideToggle(el) {
  if (!el) return;
  var hidden = getComputedStyle(el).display === 'none';
  if (hidden) {
    el.style.display = 'block';
    var h = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.style.transition = 'height 0.35s ease';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { el.style.height = h + 'px'; });
    });
    el.addEventListener('transitionend', function handler() {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el.removeEventListener('transitionend', handler);
    });
  } else {
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    el.style.transition = 'height 0.35s ease';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { el.style.height = '0'; });
    });
    el.addEventListener('transitionend', function handler() {
      el.style.removeProperty('display');
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el.removeEventListener('transitionend', handler);
    });
  }
}

document.querySelectorAll(".accordion-title").forEach((title) => {
    title.addEventListener("click", function () {
      this.parentElement.classList.toggle("accordion-wrapper-active");
      this.classList.toggle("accordion-open");
      slideToggle(this.nextElementSibling);
    });
});

document.querySelectorAll('.accordion-content dt').forEach(function(el) {
  el.addEventListener('click', function() {
    el.classList.toggle('active-tab');
    slideToggle(el.nextElementSibling);
  });
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.mobile-tab-headings');
  if (!el) return;
  el.classList.toggle('active-content');
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.faqs-accordion-content .tab_name');
  if (!el) return;
  el.classList.toggle('active-tab');
  slideToggle(el.nextElementSibling);
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.product-information-wrapper .tab-content-wrapper dt');
  if (!el) return;
  el.classList.toggle('active-tab');
  slideToggle(el.nextElementSibling);
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.part-payment span')) return;
  document.querySelectorAll('.buy-now-pay-later').forEach(function(el) { el.style.display = 'block'; });
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.x-mas-message-arrow');
  if (!el) return;
  el.classList.toggle('active');
  slideToggle(el.nextElementSibling);
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.buy-now-pay-later .icon-close')) return;
  document.querySelectorAll('.buy-now-pay-later').forEach(function(el) { el.style.display = 'none'; });
});

document.addEventListener('change', function(e) {
  var el = e.target.closest('.price-per-item__container .quantity__input');
  if (!el) return;
  var val = parseInt(el.value, 10);
  var qtyText = document.querySelector('.qty-discount-text');
  if (qtyText) {
    if (val > 2) {
      qtyText.innerHTML = 'Buy 3+, Get 10% off';
    } else if (val > 1) {
      qtyText.innerHTML = 'Buy 3, Get 10% off';
    } else {
      qtyText.innerHTML = 'Buy 2, Get 5% off';
    }
  }
  document.querySelectorAll('product-form #satcb_quantity, .satcb_qty #satcb_quantity').forEach(function(q) { q.value = el.value; });
  var formId = el.getAttribute('form');
  if (formId) {
    var form = document.getElementById(formId);
    if (form) form.querySelectorAll('[type=submit]').forEach(function(s) { s.setAttribute('unbxdparam_qty', el.value); });
  }
});

document.addEventListener('change', function(e) {
  var el = e.target.closest('#satcb_quantity');
  if (!el) return;
  var qInput = document.querySelector('.price-per-item__container .quantity__input');
  if (qInput) {
    qInput.value = el.value;
    qInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".price-per-item__container")) {
    setTimeout(() => {
      const price = parseFloat(document.querySelector(".price-per-item__container").getAttribute("data-price"));
      const total_price = price * 2;
      const discount = 0.05;
      const total = (total_price * discount).toFixed(2) / 100;
      document.querySelectorAll('.calculate-price').forEach(function(el) { el.innerHTML = 'Buy 2, Get $' + total + ' off'; });
    }, 1000);
  }
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.footer-block.link_list h2');
  if (!el) return;
  if (window.innerWidth < 750) {
    el.classList.toggle('active');
    var next = el.nextElementSibling;
    if (next) next.style.display = getComputedStyle(next).display === 'none' ? 'block' : 'none';
  }
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.faq-que');
  if (!el) return;
  el.classList.toggle('active');
  slideToggle(el.nextElementSibling);
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.category-option');
  if (!el) return;
  var cat = el.dataset.category;
  document.querySelectorAll('.category-option').forEach(function(c) { c.classList.remove('active'); });
  el.classList.add('active');
  if (cat === 'show-all') {
    document.querySelectorAll('.sub-faq').forEach(function(f) { f.style.display = ''; });
  } else {
    document.querySelectorAll('.sub-faq').forEach(function(f) { f.style.display = 'none'; });
    document.querySelectorAll('.sub-faq[data-type="' + cat + '"]').forEach(function(f) { f.style.display = ''; });
  }
});

document.addEventListener('keyup', function(e) {
  if (!e.target.closest('#faq-search')) return;
  var q = e.target.value.toLowerCase();
  document.querySelectorAll('.faq-wrapper').forEach(function(el) {
    el.style.display = el.textContent.toLowerCase().includes(q) ? '' : 'none';
  });
});

function searchFunction() {
  var input, filter, ul, li, s, p, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = ul.getElementsByTagName('li');

  for (i = 0; i < li.length; i++) {
    p = li[i].getElementsByTagName("p")[0];
    s = li[i].getElementsByTagName("span")[0];
    txtValue = (s.textContent || s.innerText) + " " + (p.textContent || p.innerText);
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}

function u_decodeAndParse(s) {
  if (s.indexOf('"') === 0) {
    s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
  }
  return u_decodeCookie(s);
}
function u_decodeCookie(s) {
  var pluses = /\+/g;
  return decodeURIComponent(s.replace(pluses, ' '));
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function readCookie(key) {
  var cookies = document.cookie.split('; ');
  var result;
  for (var i = 0, l = cookies.length; i < l; i++) {
    var parts = cookies[i].split('=');
    var name = u_decodeCookie(parts.shift());
    var cookie = parts.join('=');
    if (key && key === name) {
      try {
        result = u_decodeAndParse(cookie);
        break;
      } catch (e) {
        this.log(e);
      }
    }
  }
  return result;
}

document.addEventListener('click', function(e) {
  var el = e.target.closest('.checkout-btn, #CartDrawer-Checkout-btn');
  if (!el) return;
  var btn = document.getElementById('CartDrawer-Checkout');
  if (btn) btn.disabled = false;
  if (el.classList.contains('direct-to-checkout')) {
    el.innerHTML = "Loading Checkout <span class='dot-typing'></span>";
    if (btn) btn.click();
  } else {
    document.querySelectorAll('.cart-upsell-overlay').forEach(function(x) { x.classList.add('overlay-show'); });
    document.querySelectorAll('.cart-upsell-drawer').forEach(function(x) { x.classList.add('open-drawer'); });
  }
  resizecart();
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.cart-upsell-overlay, .cart-upsell-header .icon-close, .cart-upsell-footer .go-back-button')) return;
  document.querySelectorAll('.cart-upsell-overlay').forEach(function(x) { x.classList.remove('overlay-show'); });
  document.querySelectorAll('.cart-upsell-drawer').forEach(function(x) { x.classList.remove('open-drawer'); });
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.whey-freebie-overlay, .whey-freebie-header .icon-close')) return;
  document.querySelectorAll('.whey-freebie-wrapper').forEach(function(x) { x.classList.remove('open-whey-offer'); });
  document.querySelectorAll('.whey-freebie-drawer').forEach(function(x) { x.classList.remove('open-drawer'); });
  document.body.classList.remove('overflow-hidden');
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.bogo-freebie-overlay, .bogo-freebie-header .icon-close')) return;
  document.querySelectorAll('.bogo-freebie-wrapper').forEach(function(x) { x.classList.remove('open-bogo-offer'); });
  document.querySelectorAll('.bogo-freebie-drawer').forEach(function(x) { x.classList.remove('open-drawer'); });
  document.body.classList.remove('overflow-hidden');
});

function resizecart() {
  var header = document.querySelector('.cart-upsell-header');
  var footer = document.querySelector('.cart-upsell-footer');
  var headerHeight = header ? header.offsetHeight : 0;
  var footerHeight = footer ? footer.offsetHeight : 0;
  document.querySelectorAll('.cart-upsell-products').forEach(function(el) {
    el.style.height = (window.innerHeight - headerHeight - footerHeight) + 'px';
  });
  var wheyHeader = document.querySelector('.whey-freebie-header');
  document.querySelectorAll('.cart-whey-products').forEach(function(el) {
    el.style.height = (window.innerHeight - (wheyHeader ? wheyHeader.offsetHeight : 0)) + 'px';
  });
  var bogoHeader = document.querySelector('.bogo-freebie-header');
  document.querySelectorAll('.cart-bogo-products').forEach(function(el) {
    el.style.height = (window.innerHeight - (bogoHeader ? bogoHeader.offsetHeight : 0)) + 'px';
  });
  var card = document.querySelector('.UNX-product-col.UNX-grid-card.product-item');
  var cardHeight = card ? card.offsetHeight : 0;
  document.querySelectorAll('.collection-grid-image img').forEach(function(el) {
    el.style.maxHeight = cardHeight + 'px';
  });
}
resizecart();
window.addEventListener('resize', resizecart);

document.addEventListener('change', function(e) {
  var el = e.target.closest('.upsell-variant');
  if (!el) return;
  var opt = el.options[el.selectedIndex];
  var item = el.closest('.upsell-item');
  if (!item) return;
  var set = function(sel, val) { var x = item.querySelector(sel); if (x) x.innerHTML = val; };
  set('.sale_was__price', opt.getAttribute('the_regular_price'));
  set('.sale-new-price', opt.getAttribute('the_discounted_price'));
  set('.discount', opt.getAttribute('the_discounted_percentage'));
  set('.save-price', opt.getAttribute('the_save_price'));
  var img = opt.dataset.image;
  if (img) {
    item.querySelectorAll('img').forEach(function(i) { i.removeAttribute('srcset'); i.setAttribute('src', img); });
  }
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.mobile-darwer-close');
  if (!el) return;
  var facet = el.closest('.UNX-fxd-facet');
  if (facet) {
    facet.classList.remove('show-filter-darwer');
    var results = facet.closest('.UNX-product-results');
    if (results) results.classList.remove('on-overlay');
  }
});

document.querySelectorAll('.tab-content-wrapper img[data-src]').forEach(function(img) {
  img.src = img.dataset.src;
});

var EliteWishList = {
  Init: function(){
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
}
function swymCallbackFn(swat){
  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons(".UNX-results-container");
  })
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

function updateTop() {
  const height = document.querySelector('.announcement-bar-section')?.offsetHeight || 0;
  document.documentElement.style.setProperty('--announcement-height', `${height}px`);
}
updateTop();
window.addEventListener('resize', updateTop);

document.addEventListener('click', function(e) {
  var svg = e.target.closest('.copy-icon-wrapper svg');
  if (!svg) return;
  var wrapper = svg.closest('.right-content-wrapper');
  if (!wrapper) return;
  var strong = wrapper.querySelector('strong');
  var text = strong ? strong.textContent : '';
  var tooltip = wrapper.querySelector('.tooltip');
  function showTooltip() {
    if (!tooltip) return;
    tooltip.style.cssText = 'display:block;opacity:0;transition:opacity 0.5s ease';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { tooltip.style.opacity = '1'; });
    });
    setTimeout(function() {
      tooltip.style.opacity = '0';
      setTimeout(function() { tooltip.style.cssText = ''; }, 500);
    }, 2000);
  }
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(showTooltip);
  } else {
    var tmp = document.createElement('input');
    document.body.appendChild(tmp);
    tmp.value = text;
    tmp.select();
    document.execCommand('copy');
    tmp.remove();
    showTooltip();
  }
});

var eventsTriggered = {
  click: false,
  mousemove: false,
  scroll: false
};

function handleEvents(event) {
  var eventType = event.type;
  if (!eventsTriggered[eventType]) {
      if(window.urls){
        eventsTriggered[eventType] = true;
        for (var i = 0; i < window.urls.length; i++) {
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = window.urls[i];
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        }
      }
  }

  if (eventsTriggered.click || eventsTriggered.mousemove || eventsTriggered.scroll) {
    document.removeEventListener('click', handleEvents);
    document.removeEventListener('mousemove', handleEvents);
    document.removeEventListener('scroll', handleEvents);
  }
}

window.External_Urls = [] || window.External_Urls;

var KlaviyoPriorLoad = false;
var $url = new URL(window.location.href);

if(window.location.pathname == '/pages/get-20-off-at-elite-supplements-the-glen' || window.location.pathname == '/pages/win-10k-worth-of-supps' || window.location.pathname == '/pages/get-15-off-at-elite-supps-penrith' || window.location.pathname == '/pages/perth-warehouse-sale'){
  KlaviyoPriorLoad = true;
}
if($url.searchParams.get("utm_source") == 'google' && $url.searchParams.get("utm_medium") == 'cpc'){
  KlaviyoPriorLoad = true;
}

if(KlaviyoPriorLoad == true){
    var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Qh5vLD";
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
   // KLAVIYO APP BLOCK
   // !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
}else{
  window.External_Urls.push("https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Qh5vLD");
}

function handleEventsForExternal(event) {
    for (var i = 0; i < window.External_Urls.length; i++) {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = window.External_Urls[i];
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }

    if(KlaviyoPriorLoad == false){
     // KLAVIYO APP BLOCK
    // !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
    }

  // IMPACT ANALYTICS
    // (function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A4194594-6054-4c90-8bbf-927db5da91cf1.js','script','ire',document,window);ire('identify');

  // FLOWBOX SCRIPT
    (function(d, id) {
    if (!window.flowbox) { var f = function() { f.q.push(arguments); }; f.q = []; window.flowbox = f; }
    if (d.getElementById(id)) { return; }
    var s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1]; s.id = id; s.async = true;
    s.src = ' https://connect.getflowbox.com/flowbox.js';
    fjs.parentNode.insertBefore(s, fjs);
    })(document, 'flowbox-js-embed');

    setTimeout(function(){
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = window.floboxJs;
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    },1000);

    // setTimeout(function(){
    //   console.log("inn",$('.kl_reviews__star_rating_widget__label').length)
    //   $('.kl_reviews__star_rating_widget__label').each(function(){
    //     var $thistext = $(this).html();
    //     $(this).html($thistext.replace('ratings',''))
    //   });
    // },2000);

    (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "mixzb1zlpq");

  document.removeEventListener('click', handleEventsForExternal);
  document.removeEventListener('mousemove', handleEventsForExternal);
  document.removeEventListener('scroll', handleEventsForExternal);
}

document.addEventListener('click', handleEvents);
document.addEventListener('mousemove', handleEvents);
document.addEventListener('scroll', handleEvents);
setTimeout(function(){
  document.addEventListener('click', handleEventsForExternal);
  document.addEventListener('mousemove', handleEventsForExternal);
  document.addEventListener('scroll', handleEventsForExternal);
},3000);

if(window.location.pathname == '/'){
  function executeOnceOnScroll() {
    const scrollThreshold = 1700;
    function onScroll() {
      if (window.scrollY >= scrollThreshold) {
        if(document.getElementsByClassName("klaviyo-featured-review-block")[0]){
          document.getElementsByClassName("klaviyo-featured-review-block")[0].setAttribute("id","klaviyo-featured-reviews-carousel")
        }
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll);
  }
  executeOnceOnScroll();
}

window.update_review = function(){
  const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
  reviewWidgets.forEach(widget => {
    const ariaLabel = widget.getAttribute('aria-label');
    const starRatingMatch = ariaLabel.match(/(\d+(\.\d+)?) stars/);
    const reviewCountMatch = ariaLabel.match(/(\d+) ratings/);
    let starRating = starRatingMatch ? parseFloat(starRatingMatch[1]).toFixed(1) : null;
    const reviewCount = reviewCountMatch ? reviewCountMatch[1] : null;
    if (starRating && (parseFloat(starRating) % 1 === 0)) {
      starRating = parseInt(starRating);
    }
    if (starRating && reviewCount > 0) {
      if (widget.parentNode.querySelectorAll('.reviews__details').length == 0) {
        const reviewContainer = document.createElement('div');
        reviewContainer.classList.add('reviews__details');
        reviewContainer.innerHTML = `<div class="reviews__averange">${starRating}</div><div class="reviews__reviews">(${reviewCount})</div>`;
        widget.parentNode.insertBefore(reviewContainer, widget.nextSibling);
      }
    } else if (reviewCount <= 0 || reviewCount === null){
    }
  });
}

window.update_widget = function(){
  var counter = 0;
  const maxCount = 5;
  const intervalId = setInterval(() => {
    window.update_review();
    counter++;
    if (counter >= maxCount) {
      clearInterval(intervalId);
    }
  }, 1000);
}
window.update_widget();

function _handleSearchKey(input) {
  if (input.value.length === 0) {
    document.querySelectorAll('.search-recommend-wrapper').forEach(function(el) { el.style.display = ''; });
    document.body.classList.add('autosuggest_box_open');
  } else {
    setTimeout(function() {
      document.querySelectorAll('.search-recommend-wrapper').forEach(function(el) { el.style.display = 'none'; });
      document.body.classList.remove('autosuggest_box_open');
    }, 100);
  }
}
document.addEventListener('keypress', function(e) {
  var el = e.target.closest('.search-modal__form .unbxd-search');
  if (el) _handleSearchKey(el);
});
document.addEventListener('keyup', function(e) {
  var el = e.target.closest('.search-modal__form .unbxd-search');
  if (el) _handleSearchKey(el);
});
document.addEventListener('focusin', function(e) {
  if (!e.target.closest('.search-modal__form .unbxd-search')) return;
  document.querySelectorAll('.search-recommend-wrapper').forEach(function(el) { el.style.display = ''; });
  document.body.classList.add('autosuggest_box_open');
});
document.addEventListener('click', function(e) {
  if (!e.target.closest('.search-recommend-wrapper, .header__search')) {
    document.querySelectorAll('.search-recommend-wrapper').forEach(function(el) { el.style.display = 'none'; });
    document.body.classList.remove('autosuggest_box_open');
  }
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.variant-v2 variant-radios .form__label');
  if (el) el.classList.toggle('close-options');
});

document.addEventListener('click', function(e) {
  var el = e.target.closest('.quantity-pack-wrapper .qty-v4');
  if (el) el.classList.toggle('close-options');
});

document.addEventListener('change', function(e) {
  var el = e.target.closest('.js-variant-nutrition');
  if (!el) return;
  var id = el.value;
  var scope = el.closest('.stack-nips') || el.closest('.accordion-content');
  if (!scope) return;
  scope.querySelectorAll('.js-variant-nutrition-content').forEach(function(c) { c.style.display = 'none'; });
  scope.querySelectorAll('.js-variant-nutrition-content[data-variant="' + id + '"]').forEach(function(c) { c.style.display = 'block'; });
});

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.rounded-collection.slider');
  if (grid) {
    grid.scrollLeft = 0;
  }
  setTimeout(function(){
    if (grid) {
      grid.scrollLeft = 0;
    }
  },2000);
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('#gift_popup .close')) return;
  var popup = document.getElementById('gift_popup');
  if (popup) popup.style.display = 'none';
});


const equalizeFeatureBoxHeight = () => {
  const boxes = [...document.querySelectorAll('.ep-feature-box')];
  if (!boxes.length) return;

  boxes.forEach(b => b.style.height = 'auto');

  const maxHeight = Math.max(...boxes.map(b => b.offsetHeight));
  boxes.forEach(b => (b.style.height = `${maxHeight}px`));
};

window.addEventListener('load', equalizeFeatureBoxHeight);
window.addEventListener('resize', equalizeFeatureBoxHeight);

document.addEventListener('click', (e) => {
  if (e.target.closest('.ins-more-info')) {
    const popup = document.querySelector('.ep-info-popup');
    if (!popup) return;

    popup.style.display = 'block';
    equalizeFeatureBoxHeight();
    document.body.classList.add('overflow-hidden');
  }

  if (e.target.closest('.ep-model-close')) {
    const popup = document.querySelector('.ep-info-popup');
    if (!popup) return;

    popup.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }
});
